import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  HostListener,
  input,
  output
} from '@angular/core';

@Component({
  selector: 'lib-modal',
  imports: [
    CommonModule,
  ],
  templateUrl: './modal.component.html',
  styles: ``
})
export class ModalComponent {

  isOpen = input<boolean>(false);
  close = output<void>();
  className = input('');
  showCloseButton = input(true);
  isFullscreen = input(false);

  constructor(private el: ElementRef) {}

  ngOnInit() {
    if (this.isOpen()) {
      document.body.style.overflow = 'hidden';
    }
  }

  ngOnDestroy() {
    document.body.style.overflow = 'unset';
  }

  ngOnChanges() {
    document.body.style.overflow = this.isOpen() ? 'hidden' : 'unset';
  }

  onBackdropClick(event: MouseEvent) {
    if (!this.isFullscreen()) {
      this.close.emit();
    }
  }

  onContentClick(event: MouseEvent) {
    event.stopPropagation();
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscape(event: Event) {
    if (event instanceof KeyboardEvent && this.isOpen()) {
      this.close.emit();
    }
  }
}
